import React from 'react';
import { Card, CardContent } from './ui/card';
import { Shield } from 'lucide-react';
import exampleImage from '../src/assets/lologo.png';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">

          <div><img src={exampleImage} alt="Example" className="w-full h-auto" /></div>
          <h1 className="text-gray-900 mb-2">Work Platform</h1>
          {/* <p className="text-gray-600">Secure access to your audit management system</p> */}
        </div>

        {/* Auth Card */}
        <Card className="bg-white/80 backdrop-blur-sm border border-gray-200 shadow-xl">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <h2 className="text-gray-900 mb-2">{title}</h2>
              {subtitle && <p className="text-gray-600">{subtitle}</p>}
            </div>
            {children}
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center mt-8 text-gray-500">
          <p>&copy; 2026 Aukera Health, Inc. All rights reserved.</p>
          <p className='text-xs'>Powered by OpenTurf Technologies’s TurfAI.</p>
        </div>
      </div>
    </div>
  );
};